<template lang="pug">
k-main.admin-settings
  template( #title )
    .title
      h1.title Settings
      k-actions.header-actions( :actions='actions' :icons='icons' )
  .main-content( v-bar )
    .inner
      section
        .setting(
          v-for='setting in settings'
          :key='setting.name'
          :is='setting.component || `f-${ setting.type }`'
          v-bind='setting'
          :value='newSettings[ setting.name ]'
          @input='updateSetting( $event, setting.name )'
        )
          //- :label='setting.label'
          //- label {{ setting.label }}
          //- .component {{ setting.component || `f-${ setting.type }` }}
  k-actions.footer-actions(
    :actions='actions'
    :icons='icons'
    type='icon-text'
    @exec='doAction'
  )
</template>

<script lang="js">
import { mapState, mapActions } from 'vuex'
import KActions from '@/blocks/k-actions'
import KMain from '@/blocks/k-main'
import KObjects from '@/blocks/k-objects'
import fields from '@/fields'
import ILock from 'icons/Lock'
import IChevronUp from 'icons/ChevronUp'
import IChevronRight from 'icons/ChevronRight'
import IChevronDown from 'icons/ChevronDown'
import IAddProgram from 'icons/PlaylistPlus'
import IAddVideo from 'icons/VideoPlus'
import IAddAudio from 'icons/VolumePlus'
import IClock from 'icons/Clock'
import IEditPlaylist from 'icons/PlaylistEdit'
import IDelete from 'icons/Delete'
import ISave from 'icons/Floppy'
import IRevert from 'icons/Undo'
import { preprocessActions } from '@/lib/util'
import { Logger } from '@/lib/logger'

export default {
  name: 'AdminSettingsPage',
  mixins: [],
  components: {
    KActions,
    KMain,
    KObjects,
    ...fields
  },
  props: {},
  data() {
    return {
      icons: {
        'lock': ILock,
        'chevron-up': IChevronUp,
        'chevron-right': IChevronRight,
        'chevron-down': IChevronDown,
        'add-program': IAddProgram,
        'add-video': IAddVideo,
        'add-audio': IAddAudio,
        'clock': IClock,
        'edit-playlist': IEditPlaylist,
        'delete': IDelete,
        'save': ISave,
        'revert': IRevert,
      },
      thisSettings: {},
      newSettings: {},
    }
  },
  created() {
    // this.setSections( this.post )
    // this.setObjects( this.post )
    this.getSettings()
  },
  mounted() {},
  methods: {
    ...mapActions([ 'getModelObject', 'updateModelObject' ]),
    itemActions( section ) {
      return ( section && section.item_actions ) || []
    },
    doAction({ fn, action, item }) {
      return this[fn]( action, item )
    },
    async getSettings() {
      const settings = await this.getModelObject({ model: 'Settings' })
      this.thisSettings = settings
      this.newSettings = Object.assign( {}, settings )
    },
    updateSetting( value, name ) {
      const { handler } = this.settingsById[ name ]
      if ( handler ) {
        return this[ handler ]( value, name )
      }
      if ( !this.newSettings ) return
      this.newSettings[ name ] = value
    },
    updateTag( value, name ) {
      if ( !this.newSettings ) return
      this.newSettings[ name ] = value.id
    },
    updateEnum( value, name ) {
      if ( !this.newSettings ) return
      this.newSettings[ name ] = value.id
    },
    async commit() {
      // TODO: startloading
      const result = this.updateModelObject({
        model: 'Settings',
        ...this.changes,
      })
      Logger.debug( 'update settings', '<AdminSettingsPage>', result )()
      // TODO: if error?
      this.thisSettings = result
      // TODO: stoploading
    },
    revert() {
      this.newSettings = Object.assign({}, this.thisSettings )
    }
  },
  computed: {
    ...mapState([ 'post' ]),
    settings() {
      return ( this.post && this.post.settings ) || []
    },
    settingsById() {
      const out = {}
      for ( const s of this.settings ) {
        out[ s.name ] = s
      }
      return out
    },
    actions() {
      return (
        this.post &&
           this.post.actions &&
           preprocessActions( this.post.actions, {
             settings: this.newSettings,
             dirty: this.dirty,
           })
      ) || {}
    },
    changes() {
      const { thisSettings, newSettings } = this
      const out = {}
      for ( const k of Object.keys( thisSettings || {} )) {
        if (( k in newSettings) && newSettings[k] !== thisSettings[k] ) {
          out[k] = newSettings[k]
        }
      }
      return out
    },
    dirty() {
      const { thisSettings, newSettings } = this
      return Object.keys( thisSettings || {} ).find( k =>
        ( k in newSettings) && newSettings[k] !== thisSettings[k] )
    },
  },
}
</script>

<style lang="scss">
.admin-settings {
  section {
    > .header > .title {
      font-size: var(--s-lg);
    }
    > .body {
      > .item.denied {
        padding: var(--s-3q) var(--s-lg);
        --c-fg: grey;
      }
    }
  }
}
</style>
